


















































































import { Component, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { mixins } from "vue-class-component";
import { LanguageDto, EntityDto } from "@/server/app.dtos";
import SideComponent from "@/models/shared/side.component";
import { LayoutServiceBus } from "@/services/bus/layout.service";
import {
  GetEntitiesDtosQuery,
  GetEntitiesDtosIncludeOptions
} from "@/server/app.queries";
import { ListResponse } from "@/models/grids/list.response";
import {
  ServerGrid,
  DataServerGridOptions
} from "@/components/mixins/ServerGridMixins";
import EntitiesMenuList from "./shared/MenuList.vue";
import EntitiesService from "@/services/api/entities.service";

@Component({
  components: {
    LeftMenu: EntitiesMenuList
  }
})
export default class EntitiesListPage extends mixins(ServerGrid) {
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  @Watch("$route", { deep: true })
  onRouteChange() {
    this.Load();
  }
  entitiesService: EntitiesService = new EntitiesService();

  constructor() {
    super();
    this.gridConfigs = new DataServerGridOptions();
  }

  async created() {
    this.gridConfigs.columns = [
      {
        text: "Nome",
        value: "name",
        filterable: true,
        sortable: true
      },
      {
        text: "Número Fiscal",
        value: "fiscalidNumber",
        filterable: true,
        sortable: true
      },
      {
        text: "Empresa",
        value: "isCompany",
        filterable: false
      },
      {
        text: "",
        value: "idEntity",
        align: "end"
      }
    ];
    this.GridInit();
    await this.Load();
  }

  async Load() {
    const request = new GetEntitiesDtosQuery();
    request.init(this.$route.query);
    request.includes = new GetEntitiesDtosIncludeOptions();
    request.includes.entityGroup = true;
    request.includes.entityType = true;
    if (!request.take || request.take <= 0) {
      request.skip = 0;
      request.take = this.gridConfigs.pageSize;
    }
    this.GridSetLoading(true);
    await this.entitiesService
      .GetList(request)
      .then((result: ListResponse<EntityDto>) => this.GridLoad(result))
      .catch((error: any) => console.log(error))
      .finally(() => this.GridSetLoading(false));
  }

  viewEntity(entity: EntityDto): void {
    const comp = new SideComponent();
    comp.title = "DetailEntitySideMenuComponent";
    comp.args = {
      entity: entity
    };
    LayoutServiceBus.openSideMenu(comp);
  }

  createEntity(): void {
    const comp = new SideComponent();
    comp.title = "CreateEntitySideMenuComponent";
    LayoutServiceBus.openSideMenu(comp);
  }
}
